import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'


const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/LoginView.vue')
  },
  {
    path: '/regist',
    name: 'regist',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "registView" */ '../views/RegistView.vue')
  },
  {
    path: '/changepassword',
    name: 'changepassword',
    /** 与登录页「忘记密码」一致；短横线路径便于记忆与分享 */
    alias: ['/change-password'],
    component: () => import(/* webpackChunkName: "Changepassword" */ '../views/Changepassword.vue'),
  },
  {
    path: '/activate',
    name: 'activate',
    component: () => import(/* webpackChunkName: "activateView" */ '../views/ActivateView.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
